<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <template v-if="params.data.active === true">
      <template v-if="params.data.vamExport">
        <template
          v-if="
            (params.data.vamSynced && !params.data.vamExportError) ||
              (params.data.vamExport && !params.data.vamExportError)
          "
        >
          <img
            src="@/assets/images/logo/ba_live.svg"
            class="export-icon"
            title="BA Export Erfolgreich"
          />
        </template>
        <template
          v-else-if="
            params.data.vamExport &&
              params.data.vamSynced &&
              params.data.vamExportError
          "
        >
          <img
            src="@/assets/images/logo/ba_warning.svg"
            class="export-icon"
            title="BA Export Fehlerhaft"
          />
        </template>
      </template>
      <template
        v-if="params.data.allowOnlineApplication && websiteExpired === false"
      >
        <img
          src="@/assets/images/logo/logo-small.png"
          class="export-icon"
          :title="'Stellenmarkt von ' + from + ' bis ' + to"
        />
      </template>
      <template
        v-if="
          $store.getters['user/hasPermission']('ad_campaigns') &&
            (params.data.adCampaignBudget.googleAdsBudget !== null ||
              params.data.adCampaignBudget.facebookAdInsightBudget !== null)
        "
      >
        <span
          v-if="
            params.data.adCampaignBudget &&
              params.data.adCampaignBudget.googleAdsBudget
          "
          class="campaign-list--item-channel google"
          :class="{
            active: params.data.adCampaignBudget.googleActive
          }"
          :title="
            'Google Budget: ' +
              params.data.adCampaignBudget.googleAdsBudget +
              '€'
          "
        >
          <i class="fab fa-google"></i>
        </span>
        <span
          v-if="
            params.data.adCampaignBudget &&
              params.data.adCampaignBudget.facebookAdInsightBudget
          "
          class="campaign-list--item-channel fb"
          :class="{
            active: params.data.adCampaignBudget.facebookActive
          }"
          :title="
            'Facebook Budget: ' +
              params.data.adCampaignBudget.facebookAdInsightBudget +
              '€'
          "
        >
          <i class="fab fa-facebook-f"></i>
        </span>
      </template>
      <template
        v-if="params.data.allowOnlineApplication && websiteExpired === true"
      >
        <img
          src="@/assets/images/logo/web_warning.svg"
          class="export-icon"
          title="Stellenmarkt Datum überschritten"
        />
      </template>
    </template>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "CellRendererExport",
  data() {
    return {
      websiteExpired: false,
      from: "",
      to: ""
    };
  },
  mounted() {
    this.expiredCheck();
    this.formatDate();
  },
  methods: {
    expiredCheck() {
      var today = new Date();
      if (
        moment(today).isBefore(this.params.data.activeUntil) ||
        (this.params.data.publication &&
          moment(today).isBefore(
            this.params.data.publication.rePublishUntil
          )) ||
        (this.params.data.publication &&
          !this.params.data.publication.rePublishUntil)
      ) {
        this.websiteExpired = false;
      } else {
        this.websiteExpired = true;
      }
    },
    formatDate() {
      this.from = moment(this.params.data.activeFrom).format("DD.MM.YYYY");
      this.to = moment(this.params.data.activeUntil).format("DD.MM.YYYY");
    }
  }
};
</script>
